<template>
    <div>
        <el-table
            :data="data"
            ref="table"
            v-loading="loading"
            empty-text="載入中..."
            show-summary
            :summary-method="getTableSummaries"
            style="width: 100%"
            class="selected-service-fee-table"
        >
            <el-table-column type="index" label="#" width="40"></el-table-column>
            <el-table-column prop="systemNo" label="系統單號" width="100">
                <template slot-scope="scope">
                    <div style="font-size: 10pt; color: #888;">{{ scope.row.systemNo }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="nam" label="勞報單摘要" min-width="150">
                <template slot-scope="scope">
                    <el-button type="text" @click="onOpenServiceFee(scope.row.sno)">{{ scope.row.nam }}</el-button>
                    <div v-if="scope.row.projectNam" class="project-name-block">{{ scope.row.projectNam || "--" }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="payee" label="領款人" width="110" />
                <el-table-column prop="incomeType" label="所得類別" width="80">
                    <template slot-scope="scope">
                        <span>{{ getIncomeType(scope.row.incomeType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="incomeType" label="業別代號" width="80" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ getServiceType(scope.row.serviceType) }}</span>
                    </template>
                </el-table-column>
            <el-table-column prop="plannedPayDat" label="預計付款日" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.plannedPayDat | dateFormater("YYYY-MM-dd") }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="報酬金額" width="110" align="right">
                <template slot-scope="scope">
                    <Money :v="scope.row.amt" :precision="scope.row.cny == 'TWD' ? null : 4" />
                </template>
            </el-table-column>
            <el-table-column prop="cny" label="幣別" width="65" />
            <el-table-column prop="taxAmt" label="代扣所得稅" width="110" align="right">
                <template slot-scope="scope">
                    <Money :v="scope.row.taxAmt" />
                </template>
            </el-table-column>
            <el-table-column prop="gen2Amt" label="代扣二代健保" width="110" align="right">
                <template slot-scope="scope">
                    <Money :v="scope.row.gen2Amt" />
                </template>
            </el-table-column>
            <el-table-column prop="plannedPayWay" label="支領方式" width="100" align="right">
                    <template slot-scope="scope">
                        <span>{{ getServiceFeePlannedPayWayTxt(scope.row.plannedPayWay) }}</span>
                    </template>
                </el-table-column>
            <el-table-column v-if="data.length > 1" align="right" label="刪除" width="55">
                <template slot-scope="scope">
                    <el-button size="mini" icon="el-icon-delete" @click="onRemoveItem(scope.row.sno)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <DetailDialog :visible="detailDialog.visible" :sno="detailDialog.sno" @close="onDetailDialogClose" :isShowActions="false" />
    </div>
</template>
<script>
import _ from 'lodash';
import {
    serviceFeeStatementType, serviceTypeList, serviceType9AList, serviceType9BList, serviceFeePlannedPayWay,
} from '@/assets/commonData/options';
import DetailDialog from '@/components/dashboard/ServiceFeeStatement/DetailDialog.vue';

export default {
    name: 'selected-service-fee-table',
    components: {
        DetailDialog,
    },
    props: {
        data: {
            type: Array,
            default() {
                return [];
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            detailDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    methods: {
        getTableSummaries({ columns, data }) {
            const sums = [];
            const totalAmount = _.sumBy(data, 'amt');
            const totalTax = _.sumBy(data, 'taxAmt');
            const totalGen2 = _.sumBy(data, 'gen2Amt');

            columns.forEach((column, index) => {
                if (column.property === 'plannedPayDat') {
                    sums[index] = '總計';
                    return;
                }
                if (column.property === 'cny') {
                    if (data.length > 0) {
                        sums[index] = data[0].cny;
                        return;
                    }
                }
                if (column.property === 'taxAmt') {
                    sums[index] = totalTax !== 0 ? Number(totalTax).toLocaleString('en') : '-';
                }
                if (column.property === 'gen2Amt') {
                    sums[index] = totalGen2 !== 0 ? Number(totalGen2).toLocaleString('en') : '-';
                }
                if (column.property === 'amt') {
                    sums[index] = totalAmount !== 0 ? Number(totalAmount).toLocaleString('en', { minimumFractionDigits: 4 }) : '-';
                }
            });

            return sums;
        },
        getServiceFeeStatementType(value) {
            return _.find(serviceFeeStatementType, ['key', value])?.value;
        },
        getIncomeType(value) {
            return _.find(serviceTypeList, ['value', value])?.type;
        },
        getServiceType(value) {
            return _.find([...serviceType9AList, ...serviceType9BList], ['key', value])?.label;
        },
        getServiceFeePlannedPayWayTxt(value) {
            return _.find(serviceFeePlannedPayWay, ['key', value])?.label;
        },
        onRemoveItem(sno) {
            this.$emit('remove-item', sno);
        },
        onOpenServiceFee(sno) {
            this.detailDialog.visible = true;
            this.detailDialog.sno = sno;
        },
        onDetailDialogClose(refresh) {
            this.detailDialog.visible = false;
            this.detailDialog.sno = null;
            this.$emit('close', refresh);
        },
    },
};

</script>
<style lang="scss">
.selected-service-fee-table {
    .el-table__footer td {
        background-color: transparent;
        font-weight: bold;
    }
    .el-table__footer td {
        border-bottom: 0;
    }
    .el-table__footer td:nth-child(5) {
        // font-size: 13pt;
    }
    &::before {
        background-color: transparent !important;
    }
}
</style>
